module.exports = __webpack_public_path__ + "media/images/product_owners/pm_ccs_90-87f4dc24c532cfdb0a732dd58279e5bc.png";